module.exports = __webpack_public_path__ + "images/107_640.jpg";